import {
  REQUEST_VERIFY_COMPANY_NAME,
  REQUEST_VERIFY_EMAIL_EXISTS,
  REQUEST_VERIFY_TEAM_NAME,
  REQUEST_VERIFY_MULTIPLE_EMAIL_EXISTS,
  myTeam,
  myNetwork,
  myCompany,
  editTeam,
  SET_TEAM_MEMBERS,
  SET_TEAM,
  SET_COMPANY,
  viewTeam,
} from './types';

export * from './updateRole/actions';
export * from './myCompanyTeams/actions';
export * from './resendInvite/actions';
export * from './makeChampion/actions';

export function requestVerifyCompanyName(companyName, promise) {
  return {
    type: REQUEST_VERIFY_COMPANY_NAME,
    companyName,
    promise,
  };
}

export function requestVerifyEmailExists(email, promise) {
  return {
    type: REQUEST_VERIFY_EMAIL_EXISTS,
    email,
    promise,
  };
}

export function requestVerifyTeamName(teamName, companyId, promise) {
  return {
    type: REQUEST_VERIFY_TEAM_NAME,
    teamName,
    companyId,
    promise,
  };
}

export function requestVerifyMultipleEmailExists(emails, promise) {
  return {
    type: REQUEST_VERIFY_MULTIPLE_EMAIL_EXISTS,
    emails,
    promise,
  };
}

export function requestMyTeam() {
  return {
    type: myTeam.request,
  };
}

export function requestMyTeamSuccess(response) {
  return {
    type: myTeam.success,
    response,
  };
}

export function requestMyTeamFailure(error) {
  return {
    type: myTeam.failure,
    error,
  };
}

export function requestMyNetwork() {
  return {
    type: myNetwork.request,
  };
}

export function requestMyNetworkSuccess(response) {
  return {
    type: myNetwork.success,
    response,
  };
}

export function requestMyNetworkFailure(error) {
  return {
    type: myNetwork.failure,
    error,
  };
}

export function requestMyCompany() {
  return {
    type: myCompany.request,
  };
}

export function requestMyCompanySuccess(response) {
  return {
    type: myCompany.success,
    response,
  };
}

export function requestMyCompanyFailure(error) {
  return {
    type: myCompany.failure,
    error,
  };
}

export function requestEditTeam(teamId, payload, promise) {
  return {
    type: editTeam.request,
    teamId,
    payload,
    promise,
  };
}

export function requestEditTeamSuccess(response) {
  return {
    type: editTeam.success,
    response,
  };
}

export function requestEditTeamFailure(error) {
  return {
    type: editTeam.failure,
    error,
  };
}

export function requestViewTeam(teamId) {
  return {
    type: viewTeam.request,
    teamId,
  };
}

export function requestViewTeamSuccess(teamId, response) {
  return {
    type: viewTeam.success,
    teamId,
    response,
  };
}

export function requestViewTeamFailure(teamId, error) {
  return {
    type: viewTeam.failure,
    teamId,
    error,
  };
}

export function setTeamMembers(teamId, members) {
  return {
    type: SET_TEAM_MEMBERS,
    teamId,
    members,
  };
}

export function setTeam(companyId, team) {
  return {
    type: SET_TEAM,
    companyId,
    team,
  };
}

export function setCompany(networkId, company) {
  return {
    type: SET_COMPANY,
    networkId,
    company,
  };
}
